import { API } from "./../../../api/config";

export const getIngestionMonitorAPI = (params) => {
    return API.get("/pmbpartner/ingestion-monitor", { params })
              .then((res) => res);
};

export const getAllIngestionsAPI = (params) => {
    return API.get("/pmbpartner/ingestion-monitor/all", { params })
              .then((res) => res);
};

export const getResendStatusDataAPI = (params) => {
    return API.get("/pmbpartner/ingestion-monitor/resend-status", { params })
              .then((res) => res);
};

export const resendCustomersAPI = (payload) => {
    return API.post("/pmbpartner/ingestion-monitor/resend-to-sap", payload)
              .then((res) => res);
};

export const cancelResendAPI = (payload) => {
    return API.patch(`/pmbpartner/ingestion-monitor/cancel-resend`, payload)
              .then((res) => res);
};